export const actions = {
  GET_FOOTER: "GET_FOOTER",
};
